import { render } from "./PrizesView.vue?vue&type=template&id=0b652fbb"
import script from "./PrizesView.vue?vue&type=script&lang=js"
export * from "./PrizesView.vue?vue&type=script&lang=js"

import "./PrizesView.vue?vue&type=style&index=0&id=0b652fbb&lang=css"

import exportComponent from "/Users/peterdevos/Apps/sendcloudholidaygiftsraffle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__